import { useEffect, useState } from 'react';
import Sizes from './Sizes';
import type { Size } from './Sizes';

const MIN_MAX_WIDTHS: Record<Size, [number, number]> = {
  [Sizes.SM]: [0, 768],
  [Sizes.MD]: [768, 992],
  [Sizes.LG]: [992, Number.MAX_SAFE_INTEGER],
};

export function responsiveSize() {
  const width = window?.innerWidth;

  if (width === undefined) return null;

  return Object.keys(MIN_MAX_WIDTHS).find((size) => {
    const [min, max] = MIN_MAX_WIDTHS[size as Size];

    return width >= min && width < max;
  });
}

export function useIsSize(size: Size, { skipResizeListener = false } = {}) {
  const [currentSize, setCurrentSize] = useState(responsiveSize());

  useEffect(() => {
    if (skipResizeListener) return undefined;

    const handleResize = () => {
      const newCurrentSize = responsiveSize();
      if (newCurrentSize !== currentSize) {
        setCurrentSize(newCurrentSize);
      }
    };

    window.addEventListener('resize', handleResize, { passive: true });

    return () => window.removeEventListener('resize', handleResize);
  }, [currentSize, skipResizeListener]);

  return size === currentSize;
}

export default function isSize(size: Size) {
  return responsiveSize() === size;
}
